import { render, staticRenderFns } from "./CourseSessionLayout.vue?vue&type=template&id=50ade0e4&scoped=true"
import script from "./CourseSessionLayout.vue?vue&type=script&lang=js"
export * from "./CourseSessionLayout.vue?vue&type=script&lang=js"
import style0 from "./CourseSessionLayout.vue?vue&type=style&index=0&id=50ade0e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ade0e4",
  null
  
)

export default component.exports